import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {TwoLineOptionCard} from 'shells/option-card/two-line-option-card';

import type {EntityType} from 'nutshell-graphql-types';

import type {EntityTypeOption} from '../../../types';

import {Description} from './description';
import {getIconColor} from './helpers';

import styles from './field-mapping.module.css';

type Props = {
    control: Control;
    name: string;
    entityType: EntityType;
    entityTypeOptions: EntityTypeOption[];
    fieldLabel: string;
    onEditEmailField: (updatedEntityType: string) => void;
};

export function EntityTypeMapper(props: Props) {
    return (
        <>
            <div className='py-8'>
                <Description fieldLabel={props.fieldLabel} />
            </div>
            <Controller
                name={`${props.name}.entityType`}
                control={props.control}
                // @ts-expect-error
                render={({field}) => {
                    return (
                        <div className={styles['cards-container']}>
                            {props.entityTypeOptions.map((option) => {
                                const Icon = option.icon;

                                return (
                                    <div key={option.value} className={styles.card}>
                                        <TwoLineOptionCard
                                            title={props.fieldLabel}
                                            subtitle={option.label}
                                            icon={
                                                <Icon
                                                    size={16}
                                                    color={getIconColor(option.value)}
                                                />
                                            }
                                            isSelected={option.value === props.entityType}
                                            onClick={() => {
                                                field.onChange(option.value);
                                                // This updates the isRemovable flag on all email fields on the form
                                                props.onEditEmailField(option.value);
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    );
                }}
            />
        </>
    );
}
